export default "__VITE_ASSET__B2HOgHw9__"